import cx from 'clsx'
import { ElementType } from 'react'
import { Helmet } from 'react-helmet'

import { Category, toAllBreadcrumbs, toTopBreadcrumbs } from '../utils/breadcrumbs'
import { breadcrumb } from '../utils/ld'

import { BreadcrumbsComponent } from './BreadcrumbsComponent'

interface BreadcrumbsListProps {
  current: string
  url: string
  relatedCategories?: Category[]
  onLinkClick?: (link: string, option: any) => void
  topTitle?: string
  LinkComponent?: ElementType
}

export function BreadcrumbsList({
  url,
  current,
  onLinkClick,
  relatedCategories,
  LinkComponent,
  topTitle = 'よくあるご質問',
}: BreadcrumbsListProps) {
  const top = toTopBreadcrumbs([], current, topTitle)

  return (
    <div className={cx('faq-breadcrumb')}>
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(breadcrumb(url, top))}</script>
      </Helmet>
      {toAllBreadcrumbs(top || [], relatedCategories || []).map((hierarchies, index) => (
        <BreadcrumbsComponent
          key={index}
          links={hierarchies}
          onLinkClick={onLinkClick}
          LinkComponent={LinkComponent}
        />
      ))}
    </div>
  )
}
